export const sgDevicePixelRatio =
  2 * Math.ceil(((window.devicePixelRatio || 1) + 1) / 2);
